import React from 'react';

/**
 * In-app brand loading screen. Reuses the `.ld-*` classes defined in index.html's
 * <style> (which persists for the document's lifetime), so it is pixel-identical to
 * the instant pre-mount splash — the hand-off from splash → React loading is seamless,
 * with no white flash (html/body background is already dark).
 */
export function BrandLoader() {
  return (
    <div className="ld-screen">
      <div className="ld-orb-spin">
        <img className="ld-orb" src="/The_Circle.png" alt="" />
      </div>
      <img className="ld-word" src="/metanoia-wordmark.png" alt="METANOIA" />
    </div>
  );
}
